import { useDispatch, useSelector } from "react-redux";
import { closeGameDescriptionPop } from "../../../redux/action/member/memberAction";
import { motion } from "framer-motion";
import { Button, Checkbox, Divider } from "semantic-ui-react";
import useDescriptionConfig from "./descriptionConfig";
import { MdOutlineClose } from "react-icons/md";
import Cookies from "js-cookie";
import useDeviceType from "../../../hook/useDeviceType";
import { useTranslation } from "react-i18next";

const DescriptionDashboard = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const dispatch = useDispatch();
  const isGameDescriptionConfig = useSelector(
    (state) => state.isGameDescriptionPop
  );
  const descriptionComponent = useDescriptionConfig({
    game: isGameDescriptionConfig.game,
  });

  const isMobile = useDeviceType() === "Mobile";

  return (
    <motion.main
      onClick={() => {
        dispatch(closeGameDescriptionPop());
      }}
      className="fixed top-0 left-0 w-full h-full z-[9999999] bg-[rgb(0,0,0,0.7)] flex items-center justify-center px-common-padding-x"
    >
      <div
        className="w-full relative md:w-[500px] h-[80vh] rounded-[5px] px-common-padding-x dark:text-base-light-white bg-base-white dark:bg-base-dark"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <MdOutlineClose
          onClick={() => {
            dispatch(closeGameDescriptionPop());
          }}
          className="absolute top-[5px] right-[5px] text-3xl cursor-pointer"
        />
        <div className="flex items-center justify-center py-[15px] w-full">
          <span className="text-main-color text-xl font-medium">
            {i18n("Rules")}
          </span>
        </div>
        <Divider className="!my-[0px]" />
        <div className="overflow-y-scroll no-scrollbar h-[calc(100%-130px)]">
          {descriptionComponent?.children}
        </div>
        <Divider className="!my-[0px]" />
        <div className="flex gap-[5px] h-[70px] w-full items-center justify-center">
          <Button
            type="button"
            size="xl"
            className="!bg-main-color !text-white "
            onClick={() => {
              dispatch(closeGameDescriptionPop());
            }}
          >
            {i18n("iknow")}
          </Button>
          {!isMobile && (
            <Checkbox
              defaultChecked={
                Cookies.get(`notice_${isGameDescriptionConfig.game}`) == 1
              }
              onChange={() => {
                if (
                  Cookies.get(`notice_${isGameDescriptionConfig.game}`) == 1
                ) {
                  Cookies.remove(`notice_${isGameDescriptionConfig.game}`);
                } else {
                  Cookies.set(`notice_${isGameDescriptionConfig.game}`, 1, {
                    expires: 999,
                  });
                }
              }}
              label={i18n("noRemind")}
            />
          )}
        </div>
      </div>
    </motion.main>
  );
};

export default DescriptionDashboard;
